import segmentSaga from './segment.saga';

export default segmentSaga;
